/**
 * @file ユーザー情報取得フック（軽量版）
 *
 * SigV4認証付きGETリクエストでユーザー情報を取得し、AxiosResponseをそのまま返却する。
 * Recoilへの格納やエラーハンドリングは呼び出し元に委譲。
 */
import { AxiosResponse } from 'axios';
import { useCallback } from 'react';
import { ApiUrl } from '@/utils/constants';
import api from '@/utils/api';
import { getSigV4HeadersForGet } from '@/utils/cognito';
import { UserInfoResponse } from '@/types/api/mypage/userInfo';

/** 対象APIのエンドポイント */
const url = ApiUrl.Read.USER_INFO;

/**
 * ユーザー情報を取得する軽量フック（AxiosResponseをそのまま返却）
 * @returns execute - SigV4認証付きGETリクエストを実行し、レスポンスを返却
 */
const useGetUserInfo = () => {
  const execute = useCallback(async (): Promise<AxiosResponse<UserInfoResponse>> => {
    const headers = await getSigV4HeadersForGet(url);
    return api.get(url, headers);
  }, []);

  return { execute };
};

export default useGetUserInfo;
